import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import { StyledMenu } from '@r1-frontend/ui-react/components/select/dropdown';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { ResultMessage } from '~/src/features/full-buy/ResultMessage';

export const AddressWrapper = styled.div`
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 16px;
    }
    
    ${StyledMenu} {
        z-index: 198 !important;
    }
`;

export const SelectOtherTariff = styled.div`
    position: relative;
    flex-wrap: nowrap;
    flex-direction: column;
    row-gap: 16px;
    width: 100%;
    margin-top: 20px;
    padding: 24px 0 24px 24px;
    border-radius: ${BorderRadius.componentRadius};
    background-color: ${COLORS.BgSurface};
`;

export const SResultMessage = styled(ResultMessage)`
    align-items: center;
    padding-right: 24px;
    fill: ${COLORS.Error};

    & > div:first-child {
        flex: 0 0 40px;
        align-self: flex-start;
        width: 40px;
        height: 40px;
        margin-right: 16px;
        background-color: ${COLORS.BgMain};
        border-radius: 20px;
    }
`;

export const NoWrapText = styled.span`
    display: contents;
    white-space: nowrap;
`;

export const BoldText = styled.span`
    display: contents;
    ${FONTS.H5};
`;

export const STrobber = styled(Throbber)`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
`;
